module.exports = __webpack_public_path__ + "img/new-logo-colored.9eb7ac6f.png";